<template>
	<div id="app">
		<Header />
		<Content />
		<Footer />
	</div>
</template>

<script>
import axios from "axios"
import { baseApiUrl } from '@/global'
import { VueEasyJwt } from 'vue-easy-jwt'
import Header from "@/components/template/header"
import Content from "@/components/template/content"
import Footer from "@/components/template/footer"

export default {
	name: "App",
	components: { Header, Content, Footer },
	data: function() {
		return {
			jwt: new VueEasyJwt(),
			location:null,
			errorStr:null,
			me: {}
		}
	},
	methods: {
		validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
			const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
				this.$store.commit('toggleVisible', false)
                this.$router.push({ path: '/login' })
            } else {
				this.$store.commit('toggleVisible', true)
                this.level = decodedToken['data'].level
                this.me.id = decodedToken['data'].id
                this.me.nome = decodedToken['data'].nome
                this.me.email = decodedToken['data'].email
            }
        },
		getLocation() {
			if(!("geolocation" in navigator)) {
				this.errorStr = 'Geolocation is not available.'
				return
			}
			navigator.geolocation.getCurrentPosition(pos => {
				this.location = pos
				this.me.latitude = String (this.location.coords.latitude)
				this.me.longitude = String (this.location.coords.longitude)
				axios['put'](`${baseApiUrl}/backend/funcionarios.php?id=${this.me.id}`, this.me)
				.then(() => {})
				.catch(() => {})
			})
		}
	},
	mounted() {
		this.validaLogin()
		this.getLocation()
		// this.validTutorial()
	},
	beforeCreate() {
		document.title = 'RouteSys | Sistema Inteligente de Rastreio'
		
	}
}
</script>

<style>
body {
	margin: 0;
}

#app {
	position: relative;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

	height: 100vh;

	display: grid;

	grid-template-rows: 56px 1fr 40px;
	grid-template-columns: 1fr;
	grid-template-areas:
		"header"
		"content"
		"footer";
}
</style>